<template>
  <v-dialog 
    v-model="showDialog"
    transition="dialog-bottom-transition"
    max-width="400"
    persistent
    >
    <v-card 
      class="mx-auto"
      
      tile>
      <v-list>
        <v-subheader>Servicios y productos en la cuenta</v-subheader>
        <v-list-item
          v-for="(item, i) in invoiceItems"
          :key="i">
          <v-list-item-icon>
            <v-icon>mdi-tshirt-crew</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.descripcion"></v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <span>x{{item.cantidad}} = ${{formatDecimal(item.total)}}</span>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-card-actions class="justify-end">
        <v-btn
          text
          @click="close">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import {formatDecimal} from "../services/utils";
export default {

  name: "InvoiceDetails",
  computed: {
    ...mapGetters(['isInvoiceDetailDialogOpen','detailsToShow']),
    showDialog:{
      get: function() {
        return this.isInvoiceDetailDialogOpen;
      },
      set: function(isOpen) {
        this.showInvoiceDetailDialog(isOpen);
      }
    },
    invoiceItems(){
      const invoice = this.detailsToShow;
      const services = invoice&&invoice.servicios?JSON.parse(invoice.servicios):[];
      const products = invoice&&invoice.productos?JSON.parse(invoice.productos):[];
      const allItems = [...services, ...products];
      return allItems;
    }
  },
  methods: {
    ...mapActions(['showInvoiceDetailDialog','setItemToShow']),
    formatDecimal(num){ return formatDecimal(num)},
    close(){
      this.showDialog = false;
      this.setItemToShow(null);
    }
  },
}
</script>